export default {
    G1:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'logo',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }, 
    G2:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'our priorities', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G3:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'institute for sustainable finance', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G4:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'housing affordability',
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    S1:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'housing', // e.g., "housing" 
        'siteSection': 'housing', // e.g., "housing"
    },
    S2:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'sustainability and climate', // e.g., "housing" 
        'siteSection': 'sustainability and climate', // e.g., "housing"
    },
    S3:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'small business growth', // e.g., "housing" 
        'siteSection': 'small business growth', // e.g., "housing"
    },
    S4:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'financial health', // e.g., "housing" 
        'siteSection': 'financial health', // e.g., "housing"
    },
    S5:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'map', // e.g., "housing" 
        'siteSection': 'map', // e.g., "housing"
    },
    S6:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'a focused approach', // e.g., "housing" 
        'siteSection': 'a focused approach', // e.g., "housing"
    },
    S7:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'footer', // e.g., "housing" 
        'siteSection': 'footer', // e.g., "housing"
    },
    C1:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'housing' // e.g., 'housing'
    }, 
    C2:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'sustainability and climate' // e.g., 'housing'
    }, 
    C3:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'small business growth'
    }, 
    C4:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'financial health'
    }, 
    C5:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'lowercase user input', // e.g., 'housing'
        'clickText': 'learn more'
    }, 
    C6:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'financial health',
        'clickText': '$50 million pledge' 
    }, 
    C7:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': 'lowercase user input', // e.g., "90210", "new york", etc.
    }, 
    C8:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': 'lowercase user input', // e.g., "environment"
    }, 
    C9:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'a focused approach',
        'clickText': 'learn more about our grant process' 
    },
    C10:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'small business growth',
        'clickText': 'connect to more' 
    },
    C11: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'financial health',
        'clickText': 'banking inclusion initiative' 
    }, 
    C12: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': ''
    }, 
    C16:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'anchor link',
        'clickText': 'map image', // e.g., "environment"
    },
    C18:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'housing',
        'clickText': 'housing', // e.g., "environment"
    },
    C19:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'sustainability and climate',
        'clickText': 'sustainability and climate', // e.g., "environment"
    },
    C20:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'small business growth',
        'clickText': 'small business growth', // e.g., "environment"
    },
    C21:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'financial health',
        'clickText': 'financial health', // e.g., "environment"
    },
};